import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Modal, Button, Icon } from 'antd';

import {
  occupationInsert,
  occupationList
} from '../../../modules/occupation';

import OccupationDetails from '../form/OccupationDetails';

class AddOccupationModal extends Component {
	constructor(props){
		super(props);
		this.state = {
			loading: false,
		}
	}

	onClose() {
		this.setState({ 	
			step: 0,
		});
		this.props.toggleAddModal();
	}

	onAdded() {
		this.setState({ 	
			step: 0,
		});
		this.props.toggleAddModal();
		this.props.occupationList();
	}

	render() {
    const { loading } = this.state;
    const { selected } = this.props;

		return (
			<Modal
				title={<span><Icon type="file-add" /> {selected ? `編輯職業` : '新增職業'}</span>}
				visible={this.props.show}
				onCancel={()=>this.onClose()}
				footer={[
					<Button key="back" onClick={()=>this.onClose()} disabled={loading}>取消</Button>
				]}
				maskClosable={false}
				closable={(loading) ? false : true}
        width='1000px'
			>
				<OccupationDetails data={selected} callback={()=>this.onAdded()} show={this.props.show} />
			</Modal>
		);
	}
}

const mapStateToProps = state => ({
	router: state.router,
	userProfile: state.user.userProfile
});

const mapDispatchToProps = dispatch =>
bindActionCreators(
	{
		occupationInsert,
		occupationList,
	},
	dispatch
);

export default connect(mapStateToProps, mapDispatchToProps)(AddOccupationModal);